module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8z87h"))).then(() => parcelRequire('2KbAe'));